import React from 'react'

import { useTranslation } from '../../contexts/I18nContext'

import Styled from './RecipeTipCard.styled'

const RecipeTipCard = ({ className, tip }) => {
  const { t } = useTranslation()
  return (
    <Styled className={className}>
      <Styled.headline>
        <Styled.badge>
          {tip?.title || tip?.type?.title || t('RECIPE.TIP')}
        </Styled.badge>
        {tip?.author?.imageUrl ? (
          <Styled.authorImage
            src={tip?.author?.imageUrl}
            alt={tip?.author?.name}
          />
        ) : null}
      </Styled.headline>
      <Styled.description>{tip?.description}</Styled.description>
      {tip?.author?.name ? (
        <Styled.authorName>
          {tip.author.role
            ? `- ${tip.author.name}, ${tip.author.role}`
            : tip.author.name}
        </Styled.authorName>
      ) : null}
    </Styled>
  )
}

export default RecipeTipCard
